if (!window.reaStickyAtcInit) {
  window.reaStickyAtcInit = true;

  document.querySelectorAll('.rea-sticky-atc').forEach((bar) => {
    const sectionId = bar.dataset.section;
    const realButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const realPrice = document.getElementById(`price-${sectionId}`);
    const stickyButton = document.getElementById(`StickyATC-Submit-${sectionId}`);
    const stickyPrice = document.getElementById(`StickyATC-Price-${sectionId}`);
    if (!realButton || !stickyButton) return;

    // Reveal once the real "Add to Bag" button itself has scrolled out of
    // view, on mobile only (the CSS also hides the bar at 750px+ as a hard
    // gate). Previously this watched the entire #ProductInfo-* section —
    // which also contains the description, accordions, share button, and
    // Complete the Look block below the buy buttons — so it only stopped
    // intersecting (and the bar appeared) after scrolling past all of that,
    // far later than "past the buy buttons."
    const observer = new IntersectionObserver(
      ([entry]) => {
        bar.classList.toggle('rea-sticky-atc--visible', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(realButton);

    const syncFromRealButton = () => {
      const disabled = realButton.hasAttribute('disabled');
      stickyButton.toggleAttribute('disabled', disabled);
      const label = stickyButton.querySelector('span');
      if (label && window.variantStrings) {
        label.textContent = disabled ? window.variantStrings.soldOut : window.variantStrings.addToCart;
      }
    };

    const syncPrice = () => {
      if (realPrice && stickyPrice) stickyPrice.innerHTML = realPrice.innerHTML;
    };

    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
        if (event?.data?.sectionId !== sectionId) return;
        syncFromRealButton();
        syncPrice();
      });
    }
  });
}
